export default __webpack_public_path__ + "static/media/enfermedades.e0abbfc0.png";